import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { Address } from 'app/shared/models';

@Injectable()
export class PostalCodeService {
  private apiUrl = this.config.getConfig('postalCodeApiUrl') + '/v2/Address';
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization-ApiKey': this.config.getConfig('postalCodeApiKey')
  });

  constructor(private http: HttpClient, private config: AppConfig) {}

  public getAddress(postalCode: string, addressNumber: string): Promise<Address> {
    // Validate postal code.
    if (!postalCode || postalCode === '' || !postalCode.match(/\d+\s\w{2}/)) {
      return Promise.reject('Invalid PostalCode.');
    }

    // Validate number.
    if (!addressNumber || addressNumber === '') {
      return Promise.reject('No number given.');
    } else {
      const numberValue = addressNumber.match(/\d+/);
      if (!numberValue) {
        return Promise.reject('Invalid number.');
      }
      addressNumber = numberValue[0];
    }

    const params = {
      postalcode: postalCode,
      addressNumber
    };

    return this.http
      .get(this.apiUrl, { headers: this.headers, params })
      .toPromise()
      .then(response => response as Address)
      .catch(error => Promise.reject(error.message || error));
  }
}
